import * as React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';

import MoreVertIcon from '@mui/icons-material/MoreVert';
import { EngineeringTwoTone, Event, ViewKanban } from '@mui/icons-material';
import Service from '../../../../../util/Service';
import {Box, Menu, MenuItem, Stack} from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function NotificationCard(props) {
    const { card, close } = props;
    const [notificacao, setNotificacao] = React.useState();
    const [lista, setLista] = React.useState();

    React.useEffect(() => {
        if (card) {
            if (card && card.ids.length === 1) {
                Service.GET("/api/security/not/byId/" + card.ids[0]).then(r => setNotificacao(r));
            } else {
                let ids = "";
                for (let id of card.ids) ids += id + ",";
                ids = ids.substring(0, ids.length - 1);
                Service.GET("/api/security/not/buscaListaNot/" + ids).then(r => setLista(r));
            }
        }
    }, [card])

    return (
        <div>
            {notificacao && <NotificaCard card={notificacao} close={close}/>}
            {lista && lista.length > 1 &&
                <Stack spacing={1.5}>
                    {lista.map((r, id) => (
                        <NotificaCard key={id} card={r} close={close}/>
                    ))}
                </Stack>
            }
        </div>
    )

}

function NotificaCard({ card, close }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const navigate = useNavigate();

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };
    const handleMarcarLida=()=>{
        Service.GET("/api/security/not/marcarLido/"+card.id).then( r=>{
            handleClose();
            close();
        });
    }
    function formataData(time) {
        if (!time) return '';
        const dt = new Date(time);
        return dt.toLocaleDateString() + " " + dt.toLocaleTimeString();
    }
    function handleGoTo(src){
        Service.GET("/api/security/not/marcarLido/"+card.id).then( r=>{
            handleClose();
            close();
            navigate(src);
        });
        
    }
    const SvgImage = ({ svgString }) => {
        const svgDataUri = `data:image/svg+xml;utf8,${encodeURIComponent(svgString)}`;
        return <img width="24px" height="24px" src={svgDataUri} alt="Dynamic SVG" />;
    };

    function montaTipo() {        
        if (card.type === "solicitacao") {
            return (
                <EngineeringTwoTone />
            )
        } else if (card.type === "kanbanCard") {
            return (
                <ViewKanban />
            )
        } else if (card.type === "event") {
            return (
                <Event />
            )
        } else if (card.icone) {
            return (
                <SvgImage svgString={card.icone} />
            )
        }
        return (
            <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
                R
            </Avatar>
        )
    }

    return (
        <Card
            sx={{
                width: '100%',
                borderRadius: '10px',
                boxShadow: '0 2px 8px rgba(15, 23, 42, 0.04)', // Sombra suave moderna
                border: '1px solid #e2e8f0', // Borda sutil cinza
                borderLeft: '5px solid #1565c0', // <--- MÁGICA: Barra de destaque na esquerda
                backgroundColor: '#ffffff',
                overflow: 'hidden',
                transition: 'transform 0.2s',
                '&:hover': { transform: 'translateY(-1px)' }
            }}
        >
            <CardHeader
                avatar={
                    // Envelopamos o ícone num box com fundo azul claro higiênico
                    <Box sx={{ color: '#1565c0', display: 'flex', alignItems: 'center', bgcolor: '#eff6ff', p: 1, borderRadius: '8px' }}>
                        {montaTipo()}
                    </Box>
                }
                action={
                    <IconButton aria-label="settings" onClick={handleClick} sx={{ color: '#64748b' }}>
                        <MoreVertIcon />
                    </IconButton>
                }
                title={card.titulo}
                subheader={formataData(card.dtCriacao)}
                sx={{
                    p: '16px 16px 6px 16px',
                    '& .MuiCardHeader-title': { fontSize: '0.95rem', fontWeight: '700', color: '#0f172a' },
                    '& .MuiCardHeader-subheader': { color: '#64748b', fontSize: '0.75rem', fontWeight: '500', mt: '2px' }
                }}
            />

            <CardContent sx={{ p: '0 16px 16px 16px' }}>
                <Typography
                    variant="body2"
                    sx={{
                        color: '#334155', // Slate-grey escuro: o melhor tom do mercado para leitura de dados
                        lineHeight: '1.6', // Dá "respiro" vertical entre as linhas do texto
                        fontSize: '0.88rem',
                        fontWeight: '400',
                        letterSpacing: '0.01em'
                    }}
                    dangerouslySetInnerHTML={{ __html: card.desc }}
                />
            </CardContent>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    list: {
                        'aria-labelledby': 'basic-button',
                    },
                }}
            >
                <MenuItem onClick={handleMarcarLida}>Marcar com lida</MenuItem>
                { card && card.actions && card.actions.map((r, id)=>(
                    <MenuItem key={id} onClick={() =>handleGoTo( r.ac )}>{r.nome}</MenuItem>
                ))}
            </Menu>

        </Card>
    );
}